orders-planner-scroll
  .orders-planner-scroll
    .wrap
      .tab(onMouseDown="{this.onDown}")
  script(type="typescript").
    this.mixin('orders.planner.scroll');
